import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  stroke: "currentColor",
  d: "m20.904 10.78-2.981-3.048a.25.25 0 0 0-.367 0h-.001a.3.3 0 0 0 0 .415zm0 0 .048.056.013.022.003.007.004.008.009.02.001.005.003.006.003.01.005.02v.005l.006.034v.012m-.095-.206.096.206m0 0-.004.04v.015l-.002.018v.005l-.006.021-.001.004-.013.036-.003.006-.005.01-.015.025-.005.008zm-.056.19-.03.036-.004.004-2.988 3.055a.253.253 0 0 1-.365 0h-.002a.303.303 0 0 1 0-.416l1.678-1.717.83-.85H8.42A.28.28 0 0 1 8.153 11c0-.171.133-.287.267-.287h11.646l-.832-.85-1.678-1.716zM10.018 1c2.212 0 4.036 1.853 4.036 4.158v.978a.28.28 0 0 1-.267.288.28.28 0 0 1-.267-.288v-.978c0-1.965-1.558-3.583-3.502-3.583H5.033c-1.942 0-3.5 1.619-3.5 3.583v11.685c0 1.963 1.558 3.582 3.5 3.582h4.996c1.937 0 3.491-1.614 3.491-3.57v-.99c0-.171.132-.288.267-.288s.267.117.267.288v.99c0 2.298-1.82 4.145-4.025 4.145H5.033C2.823 21 1 19.148 1 16.843V5.158C1 2.853 2.823 1 5.033 1z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }